import { createStyles, TableCell, withStyles } from "@material-ui/core";

export const SmallestTableCell = withStyles((theme) =>
  createStyles({
    sizeSmall: {
      padding: '8px',
      fontSize: '0.75rem'
    }
  }),
)(TableCell);